import { Icon, IconProps } from ".";

export const Twitter = (props: IconProps) => {
  return (
    <Icon viewBox="0 0 24 24" {...props}>
      <path
        d="M13.494 5H16.502V5.99933H17.5013V6.99867H19.5V9.00733H18.5007V12.0053H17.5013V14.004H16.502V15.0033H15.5027V16.0027H14.5033V17.002H13.504V18.0013H11.5053V19.0007H6.49867V18.0013H4.5V16.992H6.49867V15.9927H8.49733V15.0033H6.49867V14.004H5.49933V12.9947H6.49867V12.0053H5.49933V11.006H4.5V9.99667H6.49867V9.00733H5.49933V8.00799H4.5V5.99933H5.50934V6.99867H7.508V7.998H9.50667V8.99733H11.4953V6.99867H12.4947V5.99933H13.494V5Z"
        fill="currentColor"
      />
    </Icon>
  );
};
